import { todayYmd } from "../../features/cases/dates";
import { formatServerDate } from "../cases/caseColumns";
import { auctionsOf } from "./eauctionData";

// Panel body for an e-auction ΑΦΜ: its details and every auction posting.
const EauctionPanelBody = ({ data }) => {
  const auctions = auctionsOf(data);
  const today = todayYmd();

  return (
    <div className="ds-detail">
      <dl className="ds-dl">
        {data.afm && (
          <>
            <dt>ΑΦΜ</dt>
            <dd>{data.afm}</dd>
          </>
        )}
        <dt>Σημείωση</dt>
        <dd>{data.note?.trim() || <span className="ds-muted">—</span>}</dd>
        <dt>Καταχώρηση</dt>
        <dd>{formatServerDate(data.created_at)}</dd>
        <dt>Τελ. ενημέρωση</dt>
        <dd>{formatServerDate(data.last_checked) || <span className="ds-muted">—</span>}</dd>
        {data.link && (
          <>
            <dt>Σύνδεσμος</dt>
            <dd>
              <a href={data.link} target="_blank" rel="noreferrer">
                Άνοιγμα στο eauction.gr
              </a>
            </dd>
          </>
        )}
      </dl>

      <h3 className="ds-detail-heading">
        Πλειστηριασμοί <span className="ds-muted">({auctions.length})</span>
      </h3>
      {auctions.length === 0 ? (
        <p className="ds-muted">Δεν βρέθηκαν πλειστηριασμοί για αυτό το ΑΦΜ.</p>
      ) : (
        <table className="ds-mini-table">
          <thead>
            <tr>
              <th scope="col">Διεξαγωγή</th>
              <th scope="col">Ανάρτηση</th>
            </tr>
          </thead>
          <tbody>
            {auctions.map((a, i) => {
              const upcoming = a.ymd && a.ymd >= today;
              return (
                <tr key={`${a.posted}-${a.date}-${i}`}>
                  <td>
                    <span className={upcoming ? "ds-date-upcoming" : ""}>{a.date}</span>
                    {upcoming && <span className="ds-badge ds-badge--ok">Επερχόμενος</span>}
                  </td>
                  <td className="ds-muted">{a.posted}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default EauctionPanelBody;
